import { memo } from 'react'
import { IndicatorInput, IndicatorInput_InputType } from '../../../../proto/generated/indicator'
import {
    Checkbox,
    FormControlLabel,
    Grid,
    IconButton,
    MenuItem,
    Select,
    TextField,
    Tooltip,
    Typography
} from '@mui/material'
import InfoIcon from '@mui/icons-material/Info'

export type SeriesGroupInputProps = {
    inputValues: Record<string, any>;
    fields: IndicatorInput[];
    onInputChange: (title: string, value: any) => void;
};

const SeriesGroupInputs = ({ inputValues, fields, onInputChange }: SeriesGroupInputProps) => {
    const groupedFields = fields.reduce<Record<string, IndicatorInput[]>>((acc, field) => {
        const group = field.group || ''
        if (!acc[group]) acc[group] = []
        acc[group].push(field)
        return acc
    }, {})

    return (
        <Grid container spacing={2}>
            {Object.entries(groupedFields).map(([groupName, groupFields]) => (
                <Grid item xs={12} key={groupName}>
                    {
                        groupName ? <Typography fontSize={'12px'} color={'#6a6d78'} height={'16px'} paddingTop={groupName ? '10px' : 0}
                            paddingBottom={groupName ? '20px' : 0}>
                            {groupName}
                        </Typography> : null
                    }
                    {groupFields.map((i) => (
                        <Grid
                            container
                            gap={2}
                            marginBottom={2}
                            alignItems="center"
                            key={i.code}
                        >
                            <Grid item sx={{ flex: 1, fontSize: '14px' }}>
                                {i.title}
                            </Grid>
                            <Grid item sx={{ flex: 1, display: 'flex', alignItems: 'center', gap: '4px' }}>

                                {[IndicatorInput_InputType.INTEGER, IndicatorInput_InputType.FLOAT].includes(i.type) && (
                                    <TextField
                                        value={inputValues[i.code] ?? i.defval ?? ''}
                                        type="number"
                                        defaultValue={0}
                                        inputProps={{
                                            min: i.minval,
                                            max: i.maxval,
                                            step: 1
                                        }}
                                        size="small"
                                        sx={{
                                            width: '100px',
                                            '& .MuiInputBase-input': {
                                                padding: '10px'
                                            }
                                        }}
                                        onChange={({ target }) =>
                                            onInputChange(i.code, target.value.length ? Number(target.value) : NaN)
                                        }
                                    />
                                )}

                                {i.type === IndicatorInput_InputType.STRING && (
                                    <Select
                                        value={inputValues[i.code] ?? i.defval ?? ''}
                                        sx={{
                                            width: '100px',
                                            '& .MuiInputBase-input': { padding: '10px' }
                                        }}
                                        onChange={({ target }) => onInputChange(i.code, target.value)}
                                    >
                                        {i.options.map((option) => (
                                            <MenuItem value={option} key={option}>
                                                {option}
                                            </MenuItem>
                                        ))}

                                    </Select>
                                )}

                                {i.type === IndicatorInput_InputType.BOOLEAN && (
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={
                                                    inputValues[i.code] === 'false'
                                                        ? false
                                                        : !!inputValues[i.code] || false
                                                }
                                                size="small"
                                                sx={{
                                                    '&.Mui-checked': {
                                                        color: (theme) => theme.palette.primary.main
                                                    }
                                                }}
                                                onChange={() =>
                                                    onInputChange(
                                                        i.code,
                                                        !(
                                                            inputValues[i.code] === 'false'
                                                                ? false
                                                                : !!inputValues[i.code] || false
                                                        )
                                                    )
                                                }
                                            />
                                        }
                                        label={''}
                                    />
                                )}

                                {i.tooltip && i.tooltip.trim() && (
                                    <Tooltip
                                        title={i.tooltip}
                                        arrow
                                        placement="top"
                                    >
                                        <IconButton size="small">
                                            <InfoIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                )}
                            </Grid>
                        </Grid>
                    ))}
                </Grid>
            ))}
        </Grid>
    )
}

export default memo(SeriesGroupInputs)
